import { ButtonBase } from "../ButtonBase";
import styled from "@emotion/styled";
import type { MenuButtonSize } from "./types/interfaces";

export const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: none;
`;

export const StyledButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "$size",
})<{ $size: MenuButtonSize }>`
  display: flex;
  width: ${({ $size }) => ($size === "modal" ? "72px" : "182px")};
  height: ${({ $size }) => ($size === "modal" ? "72px" : "182px")};
  padding: ${({ $size }) =>
    $size === "modal" ? "0" : "18.853px 45.569px 18.853px 44.431px"};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;

  border-radius: ${({ $size }) => ($size === "modal" ? "6px" : "18.2px")};
  background: #0d3547;
  box-shadow: 0 4.55px 4.55px rgba(0, 0, 0, 0.25);
  border: 2px solid transparent;

  color: #fff;
  text-align: center;
  cursor: pointer;
  transition: all 140ms cubic-bezier(0.2, 0.8, 0.2, 1);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;

  &.selected,
  &:hover:not(:active) {
    border-radius: ${({ $size }) => ($size === "modal" ? "6px" : "17.333px")};
    border-color: #fff;
    background:
      linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
      radial-gradient(1012.21% 166.39% at 87.5% 124.7%, #03a1c4 0%, #683b97 47%, #03a1c4 97%);
    box-shadow: 200.417px -40.083px 16.358px rgba(255, 251, 251, 0.4) inset;
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &:active:not(.selected) {
    border-radius: ${({ $size }) => ($size === "modal" ? "6px" : "17.333px")};
    border-color: #fff;
    background:
      linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
      radial-gradient(1012.21% 166.39% at 87.5% 124.7%, #03a1c4 0%, #683b97 47%, #03a1c4 97%);
    box-shadow: 200.417px -40.083px 16.358px rgba(255, 251, 251, 0.4) inset;
    transform: scale(1.1);
    filter: drop-shadow(0 0 7px rgba(255, 255, 255, 0.8));
  }
`;

export const ButtonText = styled.span`
  color: #FFF;
  margin: 0 0 10px 0;
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  white-space: pre-line;
`;
